"use strict"

export default function (image, callbackAfter, callback) {

    addScript(scripts, 'lazy-load', () => {

        var lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy-load-image"
        });

    });

}